import * as yup from 'yup';
import { l10n } from '@ott/l10n';

export const getYearValidation = () => {
  return yup.string().required(l10n('required.required'));
};
